import React from 'react';
import Products from '../products/Products';

function Home() {
  return (
    <div>
      <Products />
    </div>
  );
}

export default Home;
